
<script>
import BarList from '../components/bar-list'
import CatmktForm from './catmkt-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            catmkt: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
        }
    },

    computed: {
        catmktList: function () {
            return this.$store.getters.getCatmktList
        },
        nextPage: function () {
            return this.$store.getters.getNextPage
        }
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleEdit (cod) {
            //abre a tela de edicao            
            this.crud = SysVars.crudU;
            this.codcatmkt = cod
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codcatmkt = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codcatmkt":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadCatmkt', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        }

    },

    components: {
        BarList, CatmktForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Categoria Marketplace" 
                plural-entity="Categorias Marketplace"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela descrição">
            </bar-list>
            <br>
            <div class="default-container">
                <alert v-if="catmktList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="catmkt in catmktList" v-bind:key="catmkt.codcatmkt">
                    <div class="mark-green" v-if="catmkt.stcatmkt=='A'"></div>
                    <div class="mark-red" v-if="catmkt.stcatmkt=='I'"></div>
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-2" style="float: left">
                                <span class="lbl-list"> {{metadata.catmkt.codcatmkt.label}} </span>
                                <span class="data-list">{{ catmkt.codcatmkt }}</span>
                            </div>
                            <div class="col-md-2 col-2" style="float: left">
                                <span class="lbl-list"> {{metadata.catmkt.altern.label}} </span>
                                <span class="data-list">{{ catmkt.altern }}</span>
                            </div>
                            <div class="col-md-4 col-4" style="float: left">
                                <span class="lbl-list"> {{metadata.catmkt.nome.label}} </span>
                                <span class="lbl-title-produto">{{ catmkt.nome }}</span>
                            </div>
                            <div class="col-md-2 col-2" style="float: left">
                                <span class="lbl-list"> {{metadata.catmkt.marketplacecatmkt.label}} </span>
                                <span class="badge badge-green mb-2 float-right" v-if="catmkt.marketplacecatmkt=='1'" >B2W</span>
                                <span class="badge badge-orange mb-2 float-right" v-if="catmkt.marketplacecatmkt=='2'" >Mercado Livre</span>
                            </div>
                            <div class="col-md-2 col-12">
                                <bar-grid 
                                    :options="{barDefault: true, btnView: true, btnEdit: true}" 
                                    :moreActions="[]" 
                                    v-on:edit="handleEdit(catmkt.codcatmkt)" 
                                    v-on:view="handleEdit(catmkt.codcatmkt, true)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <catmkt-form v-if="showForm" :index="this.codcatmkt" :crud="this.crud" v-on:closeform="closeForm"></catmkt-form>
    </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/catmkt-list.vue